module.exports = __webpack_public_path__ + "static/img/0547_6.8cc6b33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0547_6.jpg
// module id = eYXH
// module chunks = 1